import './c-tab-content.scss';
import template from './tab-content.vhtml';

export default {
	template,
	props: {
		
	},
	data() {
		return {
			isOpen: false,
			isSelected: false,
			hasTopContent: false,
			hasContent: false,
			el: this,
		};
	},
	mounted() {
		this.isOpen = this.showMore;
		this.hasTopContent = this.empty( this.$slots.topContent );
		this.hasContent = this.empty( this.$slots.default );
	},
	methods: {
		foldOut() {
			this.isOpen = !this.isOpen;
		},
		empty( item ) {
			return ( typeof item !== 'undefined' && item );
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/tab-content/tab-content.js